export default __webpack_public_path__ + "static/media/activity_order_status.2041549c.svg";